import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { RenderDatePicker, SelectInput } from 'components/Common/Inputs';
import AutoCompleteInput from 'components/Common/Inputs/AutoCompleteInput';
import { toastr } from 'react-redux-toastr';
import moment from 'moment';

class AddAccountCustomerForm extends Component {
  static propTypes = {
    onConfirmCustomerLink: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      customer: null,
      validFrom: null,
      validUntil: null,
      capacity: '',
      accountNumber: null
    };

    this.onDataInputChange = this.onDataInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onCustomerIdSelectedItem = lookupValue => lookupValue && this.setState({ customer: lookupValue });

  onDataInputChange(event) {
    const { target: { name, value } } = event;
    this.setState({ [name]: value });
  }

  handleDateFromChange(newValue) {
    this.setState({ validFrom: newValue });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { customer, validUntil, accountNumber, capacity } = this.state;
    let { validFrom } = this.state;
    validFrom = validFrom == null ? moment().format('MMM DD, YYYY') : validFrom;
    const customerAccount = { customerId: customer.id, validFrom, validUntil, capacity, accountNumber };
    const { onConfirmCustomerLink } = this.props;

    if (!customer || !capacity) {
      toastr.error('', 'Please provide Customer Id and Capacity.');
      return;
    }

    onConfirmCustomerLink(customerAccount);
    this.setState({
      customer: null,
      validFrom: null,
      validUntil: null,
      capacity: '',
      accountNumber: null
    });
  }

  render() {
    const { validFrom, customer, capacity } = this.state;
    return (
      <div className="panel-body">
        <form onSubmit={ this.handleSubmit }>
          <table>
            <tbody>
              <tr>
                <td>
                  <div>
                    <label
                      htmlFor="customer-id"
                      className="panel-body-label"
                    >
                      Customer ID
                    </label>
                  </div>
                </td>
                <td>
                  <AutoCompleteInput
                    id="customer-id"
                    name="customerId"
                    category="customer"
                    placeholder="Enter customer id..."
                    className="form-select"
                    required
                    value={ customer || '' }
                    onSelectedItem={ lookupValue => this.onCustomerIdSelectedItem(lookupValue) }
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <label
                    htmlFor="capacity"
                    className="panel-body-label"
                  >
                    Capacity
                  </label>
                </td>
                <td>
                  <Field
                    component={ SelectInput }
                    name="capacity"
                    className="form-select"
                    required
                    onChange={ this.onDataInputChange }
                    value={ capacity }
                  >
                    <option value="" disabled>Select capacity from dropdown</option>
                    <option value="0">Beneficial Owner</option>
                    <option value="1">Account Holder</option>
                    <option value="2">Intermediary</option>
                    <option value="3">Introducer Financial</option>
                    <option value="4">Introducer Non Financial</option>
                  </Field>
                </td>
              </tr>
              <tr>
                <td>
                  <label
                    htmlFor="valid_from"
                    className="panel-body-label"
                  >
                    Linked From
                  </label>
                </td>
                <td className="full-width-datepicker">
                  <Field
                    component={ RenderDatePicker }
                    name="validFrom"
                    className="form-input"
                    placeholder="MMM DD, YYYY"
                    required
                    onChange={ (e, date) => this.handleDateFromChange(date) }
                    value={ validFrom }
                  />
                </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>
                  <button
                    id="link-customer-btn"
                    className="btn btn-primary"
                    type="submit"
                  >Link Customer</button>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'addAccountCustomerForm'
})(AddAccountCustomerForm);
